/**
 * Formats a phone input value as XXX-XXX-XXXX.
 * Strips non-digits, limits to 10 digits, inserts dashes.
 * Safe to use directly in an onChange handler.
 */
export const formatPhone = (value) => {
  const digits = value.replace(/\D/g, '').slice(0, 10);
  if (digits.length <= 3) return digits;
  if (digits.length <= 6) return `${digits.slice(0, 3)}-${digits.slice(3)}`;
  return `${digits.slice(0, 3)}-${digits.slice(3, 6)}-${digits.slice(6)}`;
};
